module.exports = __webpack_public_path__ + "static/hero-bg-83e64f0e011de141e7db391331b31b4a.png";